<template>
  <div id="app">
<!--    <i v-if="$route.name !== 'Login' && isFullScreen" v-on:click="normalScreen" class="el-icon-crop fullSrceeIcon"></i>-->
<!--    <i v-if="$route.name !== 'Login' && !isFullScreen" v-on:click="fullScreen" class="el-icon-full-screen fullSrceeIcon"></i>-->

    <router-view/>
  </div>
</template>

<script>
import { webSocket } from './websocket'
import { WebSocketUrl, receiveReport } from './services'
import{ mapState, mapMutations, mapActions }from'vuex';
export default {
  name: 'App',
  computed: {
    ...mapState({
      chatbotList: state=>state.chatbotList.chatbotList,
      allChatbot: state=>state.chatbotList.allChatbot,
      recordList: state=>state.chatRoom.recordList,
      currentServiceNo: state=>state.chatRoom.serviceNo,
    })
  },
  data(){
    return {
      socket: null,
      isFullScreen: false,
    }
  },

  methods: {
    ...mapMutations('chatbotList', ['setChatbotList']),
    ...mapMutations('chatRoom', ['setRecordList']),

    updateChatbotList(latestMsg){
      const newList = [...this.chatbotList];
      const { mobileNos, serviceNo, createTime, latestMessage } = latestMsg;
      const thisChatbotIndex = newList.findIndex(item=> item.maapServiceNo == serviceNo);
      console.log('setNewMessage', thisChatbotIndex, newList[thisChatbotIndex]);
      if(thisChatbotIndex > -1){
        newList[thisChatbotIndex].hasUnReadMessage = true;
        newList[thisChatbotIndex].latestMessage = latestMessage;
        newList[thisChatbotIndex].latestTime = createTime;
        newList[thisChatbotIndex].messageContent = latestMsg;
        const thisService = newList.splice(thisChatbotIndex,1)
        newList.splice(0, 0, ...thisService)
      } else {
        const allChatbot = this.allChatbot || [];
        const thisService = allChatbot.find(item=>item.maapServiceNo == serviceNo);
        if(thisService){
          newList.unshift({
            ...thisService,
            hasUnReadMessage: true,
            latestMessage: latestMessage,
            latestTime: createTime,
            messageContent: latestMsg,
          })
        }
      }
      this.setChatbotList(newList);
    },
    updateRecordList(latestMsg){
      const newList = [...this.recordList, latestMsg];
      this.setRecordList(newList);
      setTimeout(()=>{
        // console.log('historyList scrollHeight',this.$refs.historyList.scrollHeight)
        const listDom = document.getElementById('historyList')
        listDom && listDom.scrollTo(1000, listDom.scrollHeight)
        // const historyList = this.$refs.historyList;
        // historyList && window.scrollTo(1000,listDom.scrollHeight)
      },1000)
    },

    createWebSocket(socketUrl){
      const _this = this;
      const mobileNo = localStorage.getItem('mobileNo');
      console.log('websocketUrl', socketUrl, '/////', mobileNo);
      const baseURL = socketUrl || WebSocketUrl;
      const url = baseURL + '/a2papi/message_push/v1/quickAppMessage/' + mobileNo;
      console.log('创建链接。。。，当前socket:',this.socket);
      if(this.socket){
        return ;
      }
      this.socket = new webSocket({
        // url: 'ws://10.45.50.230:8021/a2papi/message_push/v1/home_data_5g/3_1',
        // url: 'ws://bizapp.5gomsg.com/a2papi/quickAppMessage/13507466790',
        url,
        onOpen: () => {
          console.log('websocket 建立连接');
        },
        onClose:()=>{
          this.socket = null;
        },
        onMessage: (data) => {
          const {
            serviceNo, mobileNos, messageId, rcsMessageInstanceDTO, sendType, sceneTemplateCode, sceneTemplateName,
            bodyText, file, location, reply
          } = data;
          const latestMsg = {
            messageSource: 'chatbot',
            createTime: new Date().getTime(), operationType: 'add',
            mobileNos, serviceNo,
            rcsMessageInstanceDTO, sendType, sceneTemplateCode, sceneTemplateName,
            bodyText, file, location, reply,
            latestMessage: '您有一条新消息'
          };
          if(serviceNo && mobileNos){
            if(serviceNo == _this.currentServiceNo){
              _this.updateRecordList(latestMsg);
            } else {
              _this.updateChatbotList(latestMsg);
            }
            if(messageId){
              const params = {
                messageId,
                mobielNo: mobileNos,
                serviceNo,
                status: "DeliveredToTerminal"
              };
              receiveReport(params);
            }
          }
        },
        onError: (data) => {
          this.socket = null;
          console.log('websocket连接失败了', data);
        }
      });
      this.socket.onCreate();
    },

    fullScreen(){
      var docElm = document.documentElement;
      //W3C
      if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
      }
      //IE11
      else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
      this.isFullScreen = true
    },
    normalScreen(){
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.isFullScreen = false
    }
  },

  mounted(){},
  // updated: function () {
  //     console.group('updated 更新完成状态===============》');
  //     console.log('this.$router',this.$router);
  // },
  beforeDestroy: function () {
    console.group('beforeDestroy 销毁前状态===============》');
    if(this.socket){
      this.socket.closeSocket();
    }
    this.socket = null;
  },
}
</script>

<style lang="less">
body{
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.fullSrceeIcon{
  font-size: 20px;
  z-index: 999;
  position: fixed;
  top: 6px;
  right: 12px;
  /* background-color: #faefdf; */
  /* border: 1px solid #2b9939; */
  color: #fff;
  border-radius: 23px;
  padding: 8px;
}
.breadcrumb-con{
  position: fixed;
  height: 48px;
  line-height: 48px;
  background-color: #2b9939;
  width: calc( 100% - 32px );
  max-width: 382px;
  top: 0;
  left: 0;
  padding: 0 16px;
  font-size: 18px;
  border-bottom: 1px solid #dddbdb;
  z-index: 99;
}
.custom-dialog .el-dialog__footer{
  display: none;
}
.custom-dialog .el-dialog__header {
  padding: 0px !important;
}
.custom-dialog .el-dialog__body{
  padding: 0px !important;
  height: 100%;
}
.alertCon{
  width: 90%;
}

.amap-sug-result {
  z-index: 999999;
}
.el-dialog--center .el-dialog__body{
  padding: 0 20px !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #2b9939 !important;
  border-color: #2b9939 !important;
}

::-webkit-scrollbar {
  width: 0px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue